import Navbar from "react-bootstrap/Navbar";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import noImage from "../../images/No_Image_Available.jpg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getLocalStorageMenuItem, setLocalStorageMenuItem, setMobileBackColor, setMobileButttonBackColor, setMobileCardBorderColor, setMobileTextColor } from "../../utility";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useEffect, useState } from "react";
import no_image from "../../images/No_Image_Available.jpg";
import { Badge, Container } from "react-bootstrap";
import { t } from "i18next";
import {
  ArrowBackOutlined,
  ArrowForwardOutlined,
  ArrowRightOutlined,
  Edit,
  LocalDining,
  LocalShipping,
  Restaurant,
} from "@mui/icons-material";
import DOMPurify from 'dompurify';

const TopNav = ({
  openBar,
  logo,
  venueName,
  handleParent,
  backToMain,
  width,
  cover,
  desc,
  label_name,
  tableName,
  tableQr,
  isDesktop,
  isMobile
}) => {
  const [params, setParams] = useSearchParams();
  const [isScrolled, setIsScrolled] = useState(false);
  const [treeData] = useState(
    getLocalStorageMenuItem("tree_data") || []
  );
  const [orderTypeDialogOpen, setOrderTypeDialogOpen] = useState(false);
  const navigate = useNavigate();

  const onImageError = (e) => {
    e.target.src = noImage;
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleBack = () => {
    if (params.get("section")) {
      navigate(
        `/${tableName}/${tableQr}/sections?section=${params.get(
          "section"
        )}&t=${params.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
        , {
          replace: true
        });
    } else {
      navigate(
        `/${tableName}/${tableQr}/sections?section=0&t=${params.get(
          "t"
        )}&lang=${getLocalStorageMenuItem("lang")}`
        , {
          replace: true
        });
    }
  };

  const createSanitizedHTML = (html) => {
    return {
      __html: DOMPurify.sanitize(html || '')
    };
  };

  // Handle order type selection
  const handleOrderTypeSelection = (type) => {
    setLocalStorageMenuItem("orderType", type);
    setOrderTypeDialogOpen(false);
  };

  // Close order type dialog
  const handleCloseOrderTypeDialog = () => {
    setOrderTypeDialogOpen(false);
  };

  // Get order type display text
  const getOrderTypeDisplayText = (type) => {
    switch (type) {
      case "dinein": return t("Dine In");
      case "pickup": return t("Pickup");
      case "delivery": return t("Delivery");
      case "browse": return t("Browsing mode");
      default: return type;
    }
  };


  return (
    <>
      <div>
        <div style={{ width: "100%" }} className="slider-mobile">
          <img
            src={cover ? cover : no_image}
            onError={onImageError}
            className={isDesktop ? `slider-desktop-image` : `slider-mobile-image`}
          />
          <Navbar
            className={`d-flex justify-content-between align-items-center mobile-top-nav alignByLang`}
            style={{
              backgroundColor:
                getLocalStorageMenuItem("theme") === "dark" ||
                  getLocalStorageMenuItem("theme") === "customize"
                  ? setMobileBackColor()
                  : "",
            }}
          >
            {!isScrolled && !window.location.pathname.includes("/labels") && (
              <Button sx={{ color: setMobileTextColor() }} onClick={openBar}>
                <MenuOutlinedIcon />
              </Button>
            )}
            {window.location.pathname.includes("/labels") && (
              <Button
                variant="text"
                className={`ms-2 dark-color cursor`}
                style={{ color: setMobileTextColor() }}
                onClick={() => handleBack()}
              >
                {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
                  <ArrowForwardOutlined sx={{ color: setMobileTextColor() }} />
                ) : (
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                )}
              </Button>
            )}


            <Navbar.Brand className="text-center">
              {logo ? (
                <img
                  src={logo || no_image}
                  className="me-4 slider-mobile-logo"
                  onError={onImageError}
                />
              ) : (
                <img
                  src={no_image}
                  className="me-4 slider-mobile-logo"
                  onError={onImageError}
                />
              )}
            </Navbar.Brand>
            {params.get("section") != 0 && !isScrolled ? (
              <Button
                onClick={handleParent}
                style={{ color: setMobileTextColor(), zIndex: 1 }}
              >
                {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
                  <ArrowBackOutlinedIcon
                    className={`${params.get("section") != 0 ? "" : "d-none"}`}
                    sx={{ color: setMobileTextColor() }}
                  />
                ) : (
                  <ArrowForwardOutlined
                    className={`${params.get("section") != 0 ? "" : "d-none"}`}
                    sx={{ color: setMobileTextColor() }}
                  />
                )}
              </Button>
            ) : (
              true
            )}
          </Navbar>
        </div>
        <div style={{ marginTop: isDesktop ? "220px" : null }} className="wellcomeScreen">
          <Container>
            <div
              className="text-center"
              style={{ paddingLeft: "24px", paddingRight: "24px" }}
            >
              <h1
                className="mb-2 head-font"
                style={{ color: setMobileTextColor() }}
              >
                {venueName}
              </h1>


              {!label_name && (

                <Box
                  className="head-font"
                  style={{ color: setMobileTextColor() }}
                  dangerouslySetInnerHTML={createSanitizedHTML(desc)}

                />

              )}

              {JSON.parse(params.get("t")) && (
                <p
                  className="mb-1 text-center sub-font"
                  style={{ color: setMobileTextColor() }}
                >
                  {treeData?.details?.table}
                </p>
              )}
              {/* Make order type clickable */}
              {!JSON.parse(params.get("t")) && getLocalStorageMenuItem("orderType") !== "dinein" && getLocalStorageMenuItem("orderType") && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    marginTop: '10px'
                  }}
                  onClick={() => setOrderTypeDialogOpen(true)}
                >
                  <Edit fontSize="small" style={{ color: setMobileTextColor() }} />

                  <p
                    className="mb-1 text-center sub-font"
                    style={{ color: setMobileTextColor() }}
                  >
                    {getOrderTypeDisplayText(getLocalStorageMenuItem("orderType"))}
                  </p>
                </div>
              )}

            </div>
          </Container>
        </div >
      </div >
      <Navbar
        className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav ${!isScrolled ? "d-none" : ""
          } alignByLang`}
        style={{
          margin: "auto",
          backgroundColor: setMobileBackColor(),
          width: width,
          height: "100px"
        }}
      >
        {!label_name ? (
          <Button sx={{ color: setMobileTextColor() }} onClick={openBar}>
            <MenuOutlinedIcon />
          </Button>
        ) : (
          <Button disabled></Button>
        )}

        <Navbar.Brand className="text-center m-0">
          <p
            className="mb-1 text-center sub-font"
            style={{ color: setMobileTextColor() }}
          >
            {venueName}
          </p>
          {JSON.parse(params.get("t")) && (
            <p
              className="mb-1 text-center sub-font"
              style={{ color: setMobileTextColor() }}
            >
              {treeData?.details?.table}
            </p>
          )}

          <p
            className="mb-1 text-center sub-font"
            style={{ color: setMobileTextColor() }}
          >
            {label_name && (
              <Badge
                style={{
                  borderRadius: "8px",
                }}
                className={`outofinstock-badge-dish-style  font-size-14 sub-font m-1`}
              >
                {t(label_name)}
              </Badge>
            )}
          </p>
          {/* Make order type clickable in fixed nav too */}
          {!JSON.parse(params.get("t")) && getLocalStorageMenuItem("orderType") !== "dinein" && getLocalStorageMenuItem("orderType") && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
              onClick={() => setOrderTypeDialogOpen(true)}
            >
              <p className="mb-1 text-center sub-font" style={{ color: setMobileTextColor() }}>
                {getOrderTypeDisplayText(getLocalStorageMenuItem("orderType"))}
              </p>
              <Edit fontSize="small" style={{ color: setMobileTextColor() }} />
            </div>
          )}
        </Navbar.Brand>

        {params.get("section") != 0 ? (
          <Button
            onClick={handleParent}
            style={{ color: setMobileTextColor() }}
          >


            {params.get("lang") === "ar" || params.get("lang") === "fa" ? (
              <ArrowBackOutlinedIcon
                className={`${params.get("section") != 0 ? "" : "d-none"}`}
                sx={{ color: setMobileTextColor() }}
              />
            ) : (
              <ArrowForwardOutlined
                className={`${params.get("section") != 0 ? "" : "d-none"}`}
                sx={{ color: setMobileTextColor() }}
              />
            )}
          </Button>
        ) : (
          <Button
            onClick={handleParent}
            style={{ color: setMobileTextColor() }}
            disabled
          ></Button>
        )}
      </Navbar>

      {/* Order Type Selection Dialog */}
      <Dialog
        open={orderTypeDialogOpen}
        onClose={handleCloseOrderTypeDialog}
        PaperProps={{
          style: {
            backgroundColor: setMobileBackColor(),
            color: setMobileTextColor(),
            borderRadius: '12px',
            padding: '16px',
          },
        }}
      >
        <DialogTitle style={{ textAlign: 'center', padding: '16px' }}>
          <Typography variant="h5" style={{ fontWeight: 'bold' }}>
            {t("Select Order Type")}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: '20px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {treeData?.details?.is_delivery_active ? (
              <Button
                className="head-font"
                variant="outlined"
                onClick={() => handleOrderTypeSelection("delivery")}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  borderColor: setMobileCardBorderColor(),
                  color: setMobileTextColor(),
                  justifyContent: 'flex-start',
                  backgroundColor: getLocalStorageMenuItem("orderType") === "delivery" ?
                    setMobileButttonBackColor() + '40' : 'transparent',
                  fontSize: 18
                }}
                startIcon={<LocalShipping />}
              >
                <div className="alignByLang">
                  <div style={{ fontWeight: 'bold' }}>{t("Delivery")}</div>
                  <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
                    {t("Get your order completed to your location")}
                  </div>
                </div>
              </Button>
            ) : null}



            {treeData?.details?.is_pickup_active ? (
              <Button
                className="head-font"
                variant="outlined"
                onClick={() => handleOrderTypeSelection("pickup")}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  borderColor: setMobileCardBorderColor(),
                  color: setMobileTextColor(),
                  justifyContent: 'flex-start',
                  backgroundColor: getLocalStorageMenuItem("orderType") === "pickup" ?
                    setMobileButttonBackColor() + '40' : 'transparent',
                  fontSize: 18
                }}
                startIcon={<LocalDining />}
              >
                <div className="alignByLang">
                  <div style={{ fontWeight: 'bold' }}>{t("Pickup")}</div>
                  <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
                    {t("Order online and pick up at the venue")}
                  </div>
                </div>
              </Button>
            ) : null}
            {treeData?.details?.is_dinein_active && params.get("t") && params.get("t") !== "null" ? (
              <Button
                className="head-font"
                variant="outlined"
                onClick={() => handleOrderTypeSelection("dinein")}
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  borderColor: setMobileCardBorderColor(),
                  color: setMobileTextColor(),
                  justifyContent: 'flex-start',
                  backgroundColor: getLocalStorageMenuItem("orderType") === "dinein" ?
                    setMobileButttonBackColor() + '40' : 'transparent',
                  fontSize: 18
                }}
                startIcon={<Restaurant />}
              >
                <div className="alignByLang">
                  <div style={{ fontWeight: 'bold' }}>{t("Dine In")}</div>
                  <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>
                    {t("Enjoy your meal at our venue")}
                  </div>
                </div>
              </Button>
            ) : null}

          </div>
        </DialogContent>
        <DialogActions style={{ padding: '16px', justifyContent: 'center' }}>
          <Button
            className="head-font"
            onClick={handleCloseOrderTypeDialog}
            style={{
              color: setMobileTextColor(),
              borderColor: setMobileCardBorderColor(),
              borderRadius: '8px',
              padding: '8px 24px',
              fontSize: 18
            }}
            variant="outlined"
          >
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default TopNav;
